import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const OptionSwitch = ({
  disabled = false,
  onChange,
  options = [],
  size = "small",
  sx,
  value,
}) => {
  if (!Array.isArray(options) || options.length === 0 || value == null) {
    return null;
  }

  return (
    <ToggleButtonGroup
      exclusive
      size={size}
      value={value}
      onChange={(_, nextValue) => {
        if (nextValue == null) return;
        onChange?.(nextValue);
      }}
      disabled={disabled}
      sx={{
        "& .MuiToggleButton-root": {
          px: 2,
          textTransform: "none",
          fontWeight: 600,
          transition: "all 0.2s ease",
        },
        "& .MuiToggleButton-root.Mui-selected": {
          bgcolor: "primary.main",
          color: "primary.contrastText",
          "&:hover": {
            bgcolor: "primary.dark",
          },
        },
        ...sx,
      }}
    >
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default OptionSwitch;
